import React, { useEffect, useState } from "react";
import "./ErrorPage.scss";
import CircularProgressWithLabel from "./componets/CircularProgressWithLabel";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const [progress, setProgress] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 5;
        if (next >= 100) {
          clearInterval(timer);
          // Redirect after short delay if needed
          setTimeout(() => navigate("/dashboard"), 500); // Optional delay
        }
        return next;
      });
    }, 800);

    return () => clearInterval(timer);
  }, [navigate]);
  return (
    <div className="errorpage">
      <div className="wraper">
        <div className="code_404">
          {/* <img src={notFoundImage} alt="404"  width={400} height={300}/> */}
          404
        </div>
        <div className="notfound">Oops! This Page Could Not Be Found....</div>
        <p>
          The page you are looking for might have been removed had its name
          changed or is temporarily unavailable. You may try any other page or
          go back to the home page.
        </p>

        <div className="components">
          <button
            className="btn_gohaome"
            onClick={() => (window.location.href = "/dashboard")}
          >
            Go to Home
          </button>{" "}
          <button
            className="btn_gohaome"
            onClick={() => (window.location.href = "/login")}
          >
            Log In
          </button>
          <div className="loader">
            <CircularProgressWithLabel
              value={progress}
              size={35}
              thickness={5}
              color="primary"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
